export default {
  getJobListingCandidate: (state) => state.jobListingCandidate,
  getJobListingCandidateByStageId: (state) => (stageId) => state.jobListingCandidates.filter(
    (jobListingCandidate) => jobListingCandidate.stageId === stageId,
  ),
};
